import { render, staticRenderFns } from "./channels.vue?vue&type=template&id=3d1fd528&scoped=true&"
import script from "./channels.js?vue&type=script&lang=js&"
export * from "./channels.js?vue&type=script&lang=js&"
import style0 from "./channels.scss?vue&type=style&index=0&id=3d1fd528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1fd528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1fd528')) {
      api.createRecord('3d1fd528', component.options)
    } else {
      api.reload('3d1fd528', component.options)
    }
    module.hot.accept("./channels.vue?vue&type=template&id=3d1fd528&scoped=true&", function () {
      api.rerender('3d1fd528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Overview/Published/Channels/channels.vue"
export default component.exports